import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	chip: {
		margin: theme.spacing(1.5, 0),
		fontSize: 14,
		padding: theme.spacing(1),
		minWidth: 170,
		display: "flex",
		flexDirection: "row-reverse",
		"& svg": {
			color: colors.gray[700]
		},
		"& svg path": {
			fill: colors.gray[700]
		}
	},
	paper: {
		width: "100%"
	},
	cancelPendingMessageQueueChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100]),
		fontSize: 14,
		height: 20
	}
}))

export default useStyles
